export default __webpack_public_path__ + "static/media/ArrowLeftIcon.40291b5c.svg";